import {
  Activity,
  CalendarDays,
  ChartLine,
  Contact,
  LayoutDashboard,
  ListTodo,
  Megaphone,
  Package,
  Settings,
  SquareKanban,
  Swords,
  Users,
  type LucideIcon,
} from "lucide-react";

import type { navItems } from "@/lib/dashboard-data";

// One icon per nav item, shared by the sidebar, the page switcher and the
// command palette so a page never shows two different icons.
export const navIconMap: Record<(typeof navItems)[number]["icon"], LucideIcon> = {
  "layout-dashboard": LayoutDashboard,
  "list-todo": ListTodo,
  activity: Activity,
  "chart-line": ChartLine,
  megaphone: Megaphone,
  swords: Swords,
  package: Package,
  "square-kanban": SquareKanban,
  users: Users,
  contact: Contact,
  "calendar-days": CalendarDays,
  settings: Settings,
};
